<template>
  <!--  <img alt="Vue logo" src="./assets/logo.png">-->
  <!--  <HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <!--  <IndexHome></IndexHome>-->
  <!--  <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav>-->
  <div id="app">
    <router-view />
    <!-- <IndexHome /> -->
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import IndexHome from './views/webViews/HomeIndex.vue'

import router, { webRoutes, mobileRoutes } from "./router/index";
import store from "./store";
// import ScrollMove from "./utils/scrollMove";
// import { useRouter } from "vue-router";
// const router = useRouter();
function debounce(func, delay) {
  let timer = null;
  return function () {
    const context = this;
    const args = arguments;
    // 如果定时器已经存在，就清除它
    if (timer) {
      clearTimeout(timer);
    }
    // 重新设置定时器
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
let currentDevice = null;
const resizeHandler = debounce(() => {
  const isMobile = window.innerWidth < 1160;
  console.log("isMobile", isMobile, webRoutes);
  if (isMobile === currentDevice) return;
  router.getRoutes().forEach((route) => router.removeRoute(route.name));
  // 添加新路由
  (isMobile ? mobileRoutes : webRoutes).forEach((route) =>
    router.addRoute(route)
  );
  currentDevice = isMobile;
  let queryStr = window.location.href.split("?")[1];
  let queryDataList;
  let obj;
  if (queryStr?.length > 0) {
    queryDataList = queryStr.split("&");
    obj = {};
    queryDataList.forEach((item) => {
      const key = decodeURIComponent(item.split("=")[0]);
      const val = decodeURIComponent(item.split("=")[1]);
      obj[key] = val;
    });
    router.replace({
      path: router.currentRoute.value.path,
      query: obj,
    });
  } else {
    router.replace({
      path: router.currentRoute.value.path,
    });
  }
}, 1000);

let wow;
export default {
  name: "App",
  components: {
    // HelloWorld,
    // IndexHome
  },
  created() {
    if (store.state.Authorization) {
      store.dispatch("getUserInfoAction");
      store.dispatch("getMemberInfoAction");
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.scrollMoveHandle);
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.scrollMoveHandle);
  },
  methods: {
    handleResize() {
      // console.log("resize===");
      this.$store.commit("setWindowWidth", window.innerWidth);
      resizeHandler();
    },
    scrollMoveHandle() {
      // console.log("scrollMoveHandle===", document.documentElement.scrollTop);
      this.$store.commit("setScrollTop", document.documentElement.scrollTop);
    },
  },
};
</script>

<style lang="less">
/* @import "./assets/css/style-starter.css"; */
/* @import "./assets/css/define-self.css"; */
body {
  overflow-y: scroll;

  .arco-picker-week-list {
    .arco-picker-week-list-item {
      visibility: hidden;
      position: relative;

      &:nth-child(1) {
        &::after {
          content: "Sun";
          visibility: visible;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      &:nth-child(2) {
        &::after {
          content: "Mon";
          visibility: visible;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      &:nth-child(3) {
        &::after {
          content: "Tue";
          visibility: visible;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      &:nth-child(4) {
        &::after {
          content: "Wed";
          visibility: visible;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      &:nth-child(5) {
        &::after {
          content: "Thu";
          visibility: visible;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      &:nth-child(6) {
        &::after {
          content: "Fri";
          visibility: visible;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      &:nth-child(7) {
        &::after {
          content: "Sat";
          visibility: visible;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
        }
      }
    }
  }
}

#app {

  /*font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;*/
  & * {
    .hidden-scrollbar;
  }
}
</style>
